// extracted by mini-css-extract-plugin
export default {"single-risk-center__status":"RiskCenterStatus_single-risk-center__status__3pN5x"};